import axios from "axios";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Pencil, Trash2, Plus, Search } from "lucide-react";

export default function Products() {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [productname, setProductname] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [batchno, setBatchno] = useState("");
  const [manufacturingdate, setManufacturingdate] = useState("");
  const [expirydate, setExpirydate] = useState("");
  const [productlist, setProductlist] = useState([]);

  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  //Fetch Product
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = () => {
    console.log("http://tntyping.com/Adminconsole/api/nutsproductslist");
    axios
      .get("http://tntyping.com/Adminconsole/api/nutsproductslist")
      .then(function (response) {
        //console.log("Response:", response.data.result);
        if (response.data.errorCode === 2) {
          Swal.fire({
            icon: "error",
            text: response.data.Message,
            width: 320,
            padding: "1em",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-xl text-sm"
            }
          });
        }

        if (response.data.errorCode === 0) {
          console.log("Response: ", response.data.result);
          setProductlist(response.data.result);
        }
      });
  };

  const onEdit = (item) => {
    setIsEditMode(true);
    setEditId(item.id);

    setProductname(item.productname);
    setPrice(item.price);
    setStock(item.stock);
    setBatchno(item.batchno);
    setManufacturingdate(item.manufacturingdate);
    setExpirydate(item.expirydate);

    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!productname) {
      Swal.fire({ icon: "warning", text: "Please enter product name" });
      return;
    }

    if (!price) {
      Swal.fire({ icon: "warning", text: "Please enter product price" });
      return;
    }

    if (!stock) {
      Swal.fire({ icon: "warning", text: "Please enter stock quantity" });
      return;
    }

    if (!batchno) {
      Swal.fire({ icon: "warning", text: "Please enter batchno" });
      return;
    }

    if (!manufacturingdate) {
      Swal.fire({ icon: "warning", text: "Please enter manufacturing date" });
      return;
    }

    if (!expirydate) {
      Swal.fire({ icon: "warning", text: "Please enter expiry date" });
      return;
    }

    try {
      setLoading(true);

      let response;

      if (isEditMode) {
        // 🔥 EDIT API
        response = await axios.post(
          "http://tntyping.com/Adminconsole/api/" +
            "editproductbyid?id=" +
            editId +
            "&productname=" +
            productname +
            "&price=" +
            price +
            "&stock=" +
            stock +
            "&batchno=" +
            batchno +
            "&manufacturingdate=" +
            manufacturingdate +
            "&expirydate=" +
            expirydate
        );
      } else {
        // 🔥 ADD API
        response = await axios.post(
          "http://tntyping.com/Adminconsole/api/" +
            "nutscreateproducts?productname=" +
            productname +
            "&price=" +
            price +
            "&stock=" +
            stock +
            "&batchno=" +
            batchno +
            "&manufacturingdate=" +
            manufacturingdate +
            "&expirydate=" +
            expirydate
        );
      }

      if (response.data.errorCode === 2) {
        Swal.fire({
          icon: "error",
          text: response.data.Message,
          width: 320,
          padding: "1em",
          confirmButtonText: "OK",
          customClass: {
            popup: "rounded-xl text-sm"
          }
        });
        return;
      }

      if (response.data.errorCode === 0) {
        Swal.fire({
          icon: "success",
          text: isEditMode
            ? "Product Updated Successfully"
            : "Product Added Successfully",
          timer: 1500,
          showConfirmButton: false,
          width: 320,
          padding: "1em",
          confirmButtonText: "OK",
          customClass: {
            popup: "rounded-xl text-sm"
          }
        });

        // Reset everything
        setShowModal(false);
        setProductname("");
        setPrice("");
        setStock("");
        setBatchno("");
        setManufacturingdate("");
        setExpirydate("");
        setIsEditMode(false);
        setEditId(null);

        fetchProducts();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Something went wrong. Please try again.",
        width: 320,
        padding: "1em",
        confirmButtonText: "OK",
        customClass: {
          popup: "rounded-xl text-sm"
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setProductname("");
    setPrice("");
    setStock("");
    setBatchno("");
    setManufacturingdate("");
    setExpirydate("");
    setIsEditMode(false);
    setEditId(null);
  };

  const onDelete = (item) => {
    Swal.fire({
      text: "Do you want to delete?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6b7280",
      reverseButtons: true,
      width: 320,
      padding: "1em",
      customClass: {
        popup: "rounded-xl text-sm"
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            "http://tntyping.com/Adminconsole/api/deleteproductbyid?id=" +
              item.id
          );

          if (response.data.errorCode === 2) {
            Swal.fire({
              icon: "error",
              text: response.data.Message
            });
            return;
          }

          if (response.data.errorCode === 0) {
            Swal.fire({
              icon: "success",
              text: "Product Deleted Successfully",
              timer: 1500,
              showConfirmButton: false,
              width: 320,
              padding: "1em",
              confirmButtonText: "OK",
              customClass: {
                popup: "rounded-xl text-sm"
              }
            });

            fetchProducts();
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            text: "Something went wrong while deleting."
          });
        }
      }
    });
  };

  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      {/* ===== Header Section ===== */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Products</h2>
          <p className="text-sm text-gray-500">
            Manage your inventory products
          </p>
        </div>

        <button
          onClick={() => {
            resetForm(); // clear old edit data
            setShowModal(true);
          }}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded-lg shadow-sm"
        >
          <Plus size={18} />
          Add Product
        </button>
      </div>

      {/* ===== Search + Info Bar ===== */}
      <div className="flex justify-between items-center">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-3 text-gray-400" />
          <input
            type="text"
            placeholder="Search product..."
            className="pl-9 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white shadow-sm"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <span className="text-sm text-gray-500">
          Total: {productlist.length} Products
        </span>
      </div>

      {/* ===== Table ===== */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
            <tr>
              <th className="p-4 text-left">Product</th>
              <th className="p-4 text-left">Price</th>
              <th className="p-4 text-left">Stock</th>
              <th className="p-4 text-left">Batch</th>
              <th className="p-4 text-left">Manufacturing Date</th>
              <th className="p-4 text-left">Expiry Date</th>
              <th className="p-4 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {productlist.map((item) => (
              <tr
                key={item.id}
                className="border-t hover:bg-gray-50 transition"
              >
                <td className="p-4 font-medium text-gray-700">
                  {item.productname}
                </td>

                <td className="p-4 text-gray-600">₹{item.price}</td>

                <td className="p-4 text-gray-600">{item.stock}</td>

                <td className="p-4 text-gray-600">{item.batchno}</td>

                <td className="p-4 text-gray-600">{formatDate(item.expirydate)}</td>

                <td className="p-4 text-gray-600">{formatDate(item.manufacturingdate)}</td>

                <td className="p-4 flex justify-center gap-4">
                  <button
                    className="text-blue-600 hover:text-blue-800 transition"
                    onClick={() => onEdit(item)}
                  >
                    <Pencil size={18} />
                  </button>

                  <button
                    className="text-red-500 hover:text-red-700 transition"
                    onClick={() => onDelete(item)}
                  >
                    <Trash2 size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ===== Pagination Footer ===== */}
        <div className="flex justify-between items-center p-4 border-t bg-gray-50">
          <span className="text-sm text-gray-500">
            Showing 1 to {productlist.length} of {productlist.length} entries
          </span>

          <div className="flex gap-2">
            <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 bg-blue-600 text-white rounded-md text-sm">
              1
            </button>
            <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-100">
              Next
            </button>
          </div>
        </div>
      </div>

      {/* ===== Modal ===== */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-2xl w-96 space-y-4 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-800">
              {isEditMode ? "Edit Product" : "Add Product"}
            </h3>

            <input
              placeholder="Product Name *"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={productname}
              onChange={(e) => setProductname(e.target.value)}
            />

            <input
              placeholder="Price *"
              type="number"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />

            <input
              placeholder="Stock *"
              type="number"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={stock}
              onChange={(e) => setStock(e.target.value)}
            />

            <input
              placeholder="Batch No *"
              type="number"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={batchno}
              onChange={(e) => setBatchno(e.target.value)}
            />

            <input
              placeholder="Manufacturing Date *"
              type="date"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={manufacturingdate}
              onChange={(e) => setManufacturingdate(e.target.value)}
            />

            <input
              placeholder="Expiry Date *"
              type="date"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={expirydate}
              onChange={(e) => setExpirydate(e.target.value)}
            />

            <div className="flex justify-end gap-3 pt-2">
              <button
                onClick={() => {
                  setShowModal(false);
                  resetForm();
                }}
                className="px-4 py-2 text-gray-600 hover:text-black"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                disabled={loading}
                className={`px-4 py-2 rounded-lg text-white transition ${
                  loading
                    ? "bg-green-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                {loading ? "Saving..." : isEditMode ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
